import { apiFetch, ApiError } from './client';

export interface TemplateRecord {
  name: string;
  language: string;
  category: string;
  status: string;
  rejectedReason: string | null;
  body: string;
  paramCount: number;
}

export interface ApprovedTemplate {
  name: string;
  language: string;
  body: string;
  paramCount: number;
}

export async function listTemplates(fresh = false): Promise<TemplateRecord[]> {
  const path = `/templates${fresh ? '?fresh=1' : ''}`;
  const data = await apiFetch<{ templates: TemplateRecord[] }>(path);
  return data.templates;
}

/** Display-only: every template of the tenant's WABA in every status (explains legacy "[name] params" transcript
 *  rows). Never used to choose or validate a send. */
export interface CatalogTemplate {
  name: string;
  language: string;
  status: string;
  body: string;
  paramCount: number;
}

export async function getTemplateCatalog(): Promise<{ configured: boolean; templates: CatalogTemplate[] }> {
  return apiFetch<{ configured: boolean; templates: CatalogTemplate[] }>('/templates/catalog');
}

export async function getApprovedTemplates(): Promise<ApprovedTemplate[]> {
  const data = await apiFetch<{ templates: ApprovedTemplate[] }>('/templates/approved');
  return data.templates;
}

export async function createTemplate(input: {
  name: string;
  language: string;
  category: string;
  body: string;
  samples: string[];
}): Promise<{ id: string; status: string }> {
  return apiFetch('/templates', { method: 'POST', body: JSON.stringify(input) });
}

export async function deleteTemplate(name: string): Promise<void> {
  await apiFetch(`/templates/${encodeURIComponent(name)}`, { method: 'DELETE' });
}

export { ApiError };
